import type { SnapshotLevel } from '../contentEntryRefs/contentEntryRefs';
import { useLPSuspenseQuery } from '../lib/hooks/useLPQuery';

export function useCyberIQLevelsQuery() {
  return useLPSuspenseQuery<CyberIqLevels>(['cyber-iq-levels'], '/cyberIq/levels');
}
export type CyberIqLevels = CyberIQLevel[];

export type CyberIQLevel = {
  id: SnapshotLevel;
  pointsThreshold: number;
  maxPoints: number;
  assetUrl: string;
};
